import React from 'react';
import Appearance from 'styles/Appearance.js';

const AFTPrivacyPolicy = () => {

    const lineHeight = 2;
    const spacing = 20;
    const titleColor = Appearance.colors.prominentText();
    const titleWeight = 700;

    const getItems = () => {

        let items = [{
            title: 'Collection of your Personal Information',
            children: [
                'We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use certain products or services available on the Site. These may include: (a) registering for an account on our Site; (b) entering a sweepstakes or contest sponsored by us or one of our partners; (c) signing up for special offers from selected third parties; (d) sending us an email message; (e) submitting your credit card or other payment information when ordering and purchasing products and services on our Site. To wit, we will use your information for, but not limited to, communicating with you in relation to services and/or products you have requested from us. We also may gather additional personal or non-personal information in the future.'
            ]
        },{
            title: 'Use of your Personal Information',
            children: [
                'AFT collects and uses your personal information to operate its website(s) and deliver the services you have requested. The personal information collected by AFT includes, but may not be limited to, your first name, last name, email address,  phone number, and mailing address. Your first and last name are used to personalize the AFT mobile app, the AFT web app, and AFT branded communications. Your email address and phone number are used during account verifications and to keep you up to date with new features, system downtime, and AFT branded promotions. Your mailing address is used to deliver location-aware results when you access features that are location dependent. Your profile photo, if you choose to provide a photo, is used to personalize your account with the AFT mobile app and the AFT web app. To provide a photo, you must choose to allow the AFT mobile app to access your photo library. Such access will never be done automatically or without your knowledge. At any time you may elect to terminate your approval to share your photo library with the AFT mobile app.',

                'AFT may also use your personally identifiable information to inform you of other products or services available from AFT and its affiliates.'
            ]
        },{
            title: 'Sharing Information with Third Parties',
            children: [
                'AFT does not sell, rent or lease its customer lists to third parties.',
                
                'AFT may, from time to time, contact you on behalf of external business partners about a particular offering that may be of interest to you. In those cases, your unique personally identifiable information (e-mail, name, address, telephone number) is not transferred to the third party. AFT may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to AFT, and they are required to maintain the confidentiality of your information.',
                
                'AFT may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on AFT or the site; (b) protect and defend the rights or property of AFT; and/or (c) act under exigent circumstances to protect the personal safety of users of AFT, or the public.'
            ]
        },{
            title: 'Automatically Collected Information',
            children: [
                'Information about your computer hardware and software may be automatically collected by AFT. This information can include: your IP address, browser type, domain names, access times and referring website addresses. This information is used for the operation of the service, to maintain quality of the service, and to provide general statistics regarding use of the AFT website.'
            ]
        },{
            title: 'Use of Cookies',
            children: [
                'The AFT website may use "cookies" to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you.',

                'One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the Web server that you have returned to a specific page. For example, if you personalize AFT pages, or register with AFT site or services, a cookie helps AFT to recall your specific information on subsequent visits. This simplifies the process of recording your personal information, such as billing addresses, shipping addresses, and so on. When you return to the same AFT website, the information you previously provided can be retrieved, so you can easily use the AFT features that you customized.',

                'You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of the AFT services or websites you visit.'
            ]
        },{
            title: 'Security of your Personal Information',
            children: [
                'AFT secures your personal information from unauthorized access, use, or disclosure. AFT uses the following methods for this purpose:',
                {
                    title: '- OAuth',
                    children: [
                        'We use an open protocol to allow secure authorization in a simple and standard method from web, mobile and desktop applications. Requests to retrieve data from or send data to GDL use this standard to safely and securely access data stored with us. All GDL requests require that a user submit a user id and a valid authorization token before access is granted. Authorization tokens are issued during the account login process and are valid for two weeks.'
                    ]
                },
                {
                    title: '- SSL Protocol',
                    children: [
                        'When personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol.'
                    ]
                },
                'We strive to take appropriate security measures to protect against unauthorized access to or alteration of your personal information. Unfortunately, no data transmission over the Internet or any wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your personal information, you acknowledge that: (a) there are security and privacy limitations inherent to the Internet which are beyond our control; and (b) security, integrity, and privacy of any and all information and data exchanged between you and us through this Site cannot be guaranteed.'
            ]
        },{
            title: 'Children Under Thirteen',
            children: [
                'AFT does not knowingly collect personally identifiable information from children under the age of thirteen. If you are under the age of thirteen, you must ask your parent or guardian for permission to use this website.'
            ]
        },{
            title: 'E-mail Communications',
            children: [
                'From time to time, AFT may contact you via email for the purpose of providing announcements, promotional offers, alerts, confirmations, surveys, and/or other general communication.'
            ]
        },{
            title: 'External Data Storage Sites',
            children: [
                'We may store your data on servers provided by third party hosting vendors with whom we have contracted.'
            ]
        },{
            title: 'Changes to this Statement',
            children: [
                'AFT reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by sending a notice to the primary email address specified in your account, by placing a prominent notice on our site, and/or by updating any privacy information on this page. Your continued use of the Site and/or Services available through this Site after such modifications will constitute your: (a) acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound by that Policy.'
            ]
        }];

        return items.map(getItemComponent);
    }

    const getItemComponent = (item, index) => (
        <span 
        key={index}
        style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginTop: spacing,
            lineHeight: lineHeight
        }}>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
            }}>
                {item.title}
            </span>
            
            {item.children.map((child, index) => {
                if(typeof(child) === 'string') {
                    return child;
                }
                return getItemComponent(child, index)
            })}
        </span>
    )

    return (
        <>
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center'
        }}>
            <span style={{
                ...Appearance.textStyles.header({ color: Appearance.colors.prominentText() }),
                marginBottom: spacing
            }}>{'Applied Fire Technologies (AFT) Privacy Policy'}</span>
        </div>

        <span style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginBottom: spacing,
            lineHeight: lineHeight
        }}>
            {'Protecting your private information is our priority. This Statement of Privacy applies to Aftplatform.com and Applied Fire Technologies and governs data collection and usage. For the purposes of this Privacy Policy, unless otherwise noted, all references to Applied Fire Technologies include Aftplatform.com and AFT.'}
        </span>

        <span style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginBottom: spacing,
            lineHeight: lineHeight
        }}>
            {'The AFT website is a Digital collection of sales from field advisors site. The AFT mobile app for iOS and Android devices is a digital collection of sales from field advisors mobile application. By using the AFT website, you consent to the data practices described in this statement.'}
        </span>

        {getItems()}

        <span style={{
            ...Appearance.textStyles.title(),
            display: 'block',
            whiteSpace: 'normal',
            marginTop: spacing,
            lineHeight: lineHeight
        }}>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
            }}>{'Contact Information'}</span>

            {'AFT welcomes your questions or comments regarding this Statement of Privacy. If you believe that AFT has not adhered to this Statement, please contact AFT at:'}

            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Applied Fire Technologies'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
            }}>{'825 W Sandy Lake Rd Ste 190'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginBottom: spacing
            }}>{'Coppell, Texas 75019'}</span>

            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Email Address:'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginBottom: spacing
            }}>{'privacy@aftplatform.com'}</span>

            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Telephone number:'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginBottom: spacing
            }}>{'+1 (972) 393-5500'}</span>
            <span style={{
                display: 'block',
                fontWeight: titleWeight,
                color: titleColor,
                marginTop: spacing,
            }}>{'Effective as of June 13, 2023'}</span>
        </span>
        </>
    )
}

export default AFTPrivacyPolicy;
